import React from "react";
import TabsBase from "./TabsBase";
import {Tab, Tabs} from "react-bootstrap";
import '../../../assets/sass/global/tabs/horizontal-tab.scss';

class HorizontalTabs extends TabsBase {
    /**
     * Renders content of VerticalTabs component.
     * @returns {React.ReactNode} The VerticalTabs content.
     */
    renderContent = () => {
        const id = this.customId();
        const defaultKey = this.defaultKey();
        const items = this.items();

        return (
            <Tabs id={id} defaultActiveKey={defaultKey}>
                {items.map((item, index) => <Tab key={index} className="item" eventKey={item.key} title={item.header}> {item.content} </Tab>)}
            </Tabs>
        );
    };

    /**
     * Returns the custom classes of horizontal tab component.
     * @returns {React.ReactNode} The custom classes.
     */
    customClasses = () => 'horizontal-tab';
}

export default HorizontalTabs;
